import React, { useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import * as actions from "../../redux/actions";
import { img, staticsUrl } from "../../config";
import * as statsCalc from "../../components/Statistics/statsCalc";
import statsConfig from "../../config/stats.json";
import { getDailyTimestamp, secsToStr } from "../../tools";
// import { showSpinner, hideSpinner } from '../../redux/actions';
import {
  getCourses,
  getCourseIds,
  getCourseSections,
  getSection,
  getGameset,
  getExercise,
  getExerciseImages,
  getSectionHistoryImages,
  getCourseHistoryImages,
  getAllHistoryImages,
} from "../../redux/actions/crawler";
const devApi = axios.create({
  baseURL: "http://127.0.0.1:3000/xapi",
});

const mp301 = staticsUrl + "/resources/storyElementHistory/5157/h_1.1.mp3";
const mp302 = staticsUrl + "/resources/storyElementHistory/5158/h_1.2.mp3";
const mp303 = staticsUrl + "/resources/storyElementHistory/5159/h_1.3.mp3";
const mp304 = staticsUrl + "/resources/storyElementHistory/5160/h_1.4.mp3";
const mp305 = staticsUrl + "/resources/storyElementHistory/5161/h_1.5.mp3";
const mp306 = staticsUrl + "/resources/storyElementHistory/5162/h_1.6.mp3";
const mp307 = staticsUrl + "/resources/storyElementHistory/5163/h_1.7.mp3";
const mp308 = staticsUrl + "/resources/storyElementHistory/5164/h_1.8.mp3";
const mp309 = staticsUrl + "/resources/storyElementHistory/5165/h_1.9.mp3";
const mp310 = staticsUrl + "/resources/storyElementHistory/5166/h_1.10.mp3";

function Ui(props) {
  const [consol, setConsol] = useState("");
  const [base64, setBase64] = useState();
  const [config, setConfig] = useState({ size: 500, quality: 25 });

  const preloadSound = (img) => {
    const src = img;
    const sound = document.createElement("audio");
    if ("src" in sound) {
      sound.autoPlay = false;
      sound.preload = "auto";
    }
    sound.src = src;
    document.body.appendChild(sound);
    return sound;
  };

  const toConsole = (data) => {
    if (typeof data === "object")
      return setConsol(JSON.stringify(data, null, 2));
    if (typeof data === "string") return setConsol(data);
  };

  const showResult = async (fn) => {
    props.showSpinner();
    try {
      const result = await fn();
      toConsole(result);
    } catch (err) {
      toConsole(err);
    }
    props.hideSpinner();
  };

  const getExampleImage = () => {
    const url =
      staticsUrl +
      "/resources/storyElementImage/7/it%20is%20mark%27s%20first.jpg";
    axios.get(url, { responseType: "arraybuffer" }).then((response) => {
      const buffer = Buffer.from(response.data, "binary");
      sendImgToDevApi(buffer);
      setBase64(buffer.toString("base64"));
    });
  };

  const sendImgToDevApi = (buffer) => {
    const data = {
      data: buffer.toString("base64"),
      path: "/resources/storyElementImage/7/it%20is%20mark%27s%20first.jpg",
    };
    devApi.post("/upload/history", data);
  };

  const saveDefaultConfig = () => {
    const config = { size: 500, quality: 25 };
    devApi.post("/config", config);
  };

  const loadConfig = () => {
    devApi.get("/config").then((res) => {
      const config = res.data;
      let valid = true;
      if (!config || !config.size || !config.quality) valid = false;
      if (valid) {
        setConfig(config);
        props.notify("Config loaded", "success");
        toConsole(config);
      } else {
        props.notify("Error loading config", "error");
      }
    });
  };

  const getCachedImages = () => {
    devApi.get("/upload/history").then((res) => {
      toConsole(res.data);
    });
  };

  return (
    <div className="container default-fx">
      <img
        src={`data:image/jpeg;charset=utf-8;base64,${base64}`}
        style={{ maxHeight: 200 }}
      />
      {/* <div>
        <h2>Mp3</h2>
        <audio preload="auto" src={mp302} crossOrigin="anonymous" />
        <iframe name="aud" src={mp303} style={{ width: 1, height: 1, border: 'none', opacity: 0.01 }} />
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp301)}>1</Button>
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp302)}>2</Button>
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp303)}>3</Button>
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp304)}>4</Button>
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp305)}>5</Button>
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp306)}>6</Button>
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp307)}>7</Button>
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp308)}>8</Button>
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp309)}>9</Button>
        <Button variant="contained" color="primary" onClick={() => preloadSound(mp310)}>10</Button>
      </div> */}
      <div>
        <h2>Crawler partial functions</h2>
        <Button
          variant="contained"
          onClick={() => showResult(getCourses)}
          color="primary"
        >
          Courses
        </Button>
        <Button
          variant="contained"
          onClick={() => showResult(getCourseIds)}
          color="primary"
        >
          Course IDs
        </Button>
        <Button
          variant="contained"
          onClick={() => showResult(() => 183)}
          color="primary"
        >
          1.0 Sections
        </Button>
        <Button
          variant="contained"
          onClick={() => showResult(() => getGameset(266))}
          color="primary"
        >
          Gameset 266
        </Button>
        <Button
          variant="contained"
          onClick={() => showResult(() => getSection(66))}
          color="primary"
        >
          Section 66
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            showResult(() => getExercise("HISTORY", "presentation", 58))
          }
          color="primary"
        >
          Exercise 58
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            showResult(() => getExerciseImages("HISTORY", "presentation", 58))
          }
          color="primary"
        >
          IMG from Ex. 58
        </Button>
        <Button
          variant="contained"
          onClick={() => showResult(() => getSectionHistoryImages(66))}
          color="primary"
        >
          IMG from Hist Sec. 66
        </Button>
        <Button
          variant="contained"
          onClick={() => showResult(() => getCourseHistoryImages(183))}
          color="primary"
        >
          IMG from Hist Course SA 1.0
        </Button>
        <Button
          variant="contained"
          onClick={() => showResult(() => getAllHistoryImages())}
          color="primary"
        >
          All History Images
        </Button>
      </div>
      <div>Dev api</div>
      <Button
        variant="contained"
        onClick={() => toConsole(config)}
        color="primary"
      >
        Show Config
      </Button>
      <Button variant="contained" onClick={saveDefaultConfig} color="primary">
        Save default Config
      </Button>
      <Button variant="contained" onClick={loadConfig} color="primary">
        Load Config
      </Button>
      <Button
        variant="contained"
        onClick={() => showResult(() => devApi.get("/"))}
        color="primary"
      >
        Ping Dev Api
      </Button>
      <Button variant="contained" onClick={getExampleImage} color="primary">
        Get image from api
      </Button>
      <Button variant="contained" onClick={getCachedImages} color="primary">
        Get cached images
      </Button>
      <div>
        <h2>Hot Points</h2>
        <Button
          variant="contained"
          onClick={() => {
            props.getHotPointsImages();
          }}
          color="primary"
        >
          Hot-Points images
        </Button>
      </div>
      <div>
        <textarea
          value={consol}
          style={{ width: "100%", height: 400 }}
          onChange={() => {}}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { auth, notes, config, messages, userState, tools } = state;
  return { auth, notes, config, messages, userState, tools };
};

export default connect(mapStateToProps, actions)(Ui);
